import {Banner} from '@primer/react'
import {useState} from 'react'

interface SavedViewMutationErrorBannerProps {
  message: string | null
  onRetry?: () => void
  isRetrying?: boolean
  className?: string
}

function focusBannerOnMount(node: HTMLElement | null) {
  if (node) node.focus({preventScroll: true})
}

export function SavedViewMutationErrorBanner({
  message,
  onRetry,
  isRetrying = false,
  className,
}: SavedViewMutationErrorBannerProps) {
  // Keep the last message visible while a retry is in flight so focus stays
  // on "Try again".
  const [stickyMessage, setStickyMessage] = useState<string | null>(message)
  const nextMessage = message ?? (isRetrying ? stickyMessage : null)
  if (nextMessage !== stickyMessage) setStickyMessage(nextMessage)

  if (!stickyMessage) return null

  return (
    <Banner
      ref={focusBannerOnMount}
      className={className}
      variant="critical"
      title={stickyMessage}
      primaryAction={
        onRetry ? (
          <Banner.PrimaryAction onClick={onRetry} loading={isRetrying} loadingAnnouncement="Retrying">
            Try again
          </Banner.PrimaryAction>
        ) : undefined
      }
    />
  )
}
